import * as actionTypes from '../../Constants/customFieldActionTypes';
import * as customFieldServices from "../../services/customFields/index";
import API from '../../Constants/customField/API'


export function reset(originalCustomFields) {
    return {
        type: actionTypes.CUSTOM_FIELD_RESET,
        payload: { originalCustomFields: originalCustomFields }
    }    
}

export function resetCustomField(originalCustomFields) {
    return  dispatch => {
        //need to call API to get the Data
        return dispatch(reset(originalCustomFields))
    }
}



export function save(editedCustomFields) {
    return {
        type: actionTypes.CUSTOM_FIELD_SAVE,
        payload: { editedCustomFields: editedCustomFields }
    }    
}

export function saveCustomField(editedCustomFields,firmID) {
    var data = {
        CustomFieldDetails: {
            firmID: firmID,
            customFields:editedCustomFields
        },
        oAuthToken: "122"
    }
  
    return async dispatch => { 
        var getCustomFields;
        var saveCustomFieldResponse = await customFieldServices.cfRequest.saveCustomFields(API.saveCustomField, data);
        if (saveCustomFieldResponse.statusCode === 200) {
            getCustomFields = await customFieldServices.cfRequest.getAllCustomFields(API.getCustomField, firmID, "test");
            getCustomFields.customFields.map((cfield) => {
                cfield.isSingleSelectOptionsEdited = false;
            });   
            dispatch(save(getCustomFields.customFields))
        }
       
        return saveCustomFieldResponse;
    }
}